import capitalize from 'lodash/capitalize';
import { FC, useEffect } from 'react';
import styled from 'styled-components';

import { DaysOfWeek, SkipDaysOfWeek } from 'modules/workflows/types';
import { CHECKBOX_STATUS, Checkbox } from 'ui/checkbox';
import { Label, fontSizes, fontWeights, spacing } from 'ui/theme';
import noop from 'utils/noop';

export const CheckboxWrapper = styled.div<{ isDisabled: boolean }>`
  display: flex;
  margin-bottom: ${spacing.half};
`;

export const CheckboxLabel = styled(Label)`
  font-weight: ${fontWeights.regular};
  line-height: ${fontSizes.s16};
  margin-left: ${spacing.quarter};
`;

export const DAYS_OF_WEEK: DaysOfWeek[] = [
  DaysOfWeek.Monday,
  DaysOfWeek.Tuesday,
  DaysOfWeek.Wednesday,
  DaysOfWeek.Thursday,
  DaysOfWeek.Friday,
  DaysOfWeek.Saturday,
  DaysOfWeek.Sunday,
];

export const getSkipDaysOfWeekStub = (): SkipDaysOfWeek =>
  DAYS_OF_WEEK.reduce((acc, day) => ({ ...acc, [day]: false }), {});

export interface SkipDaysOfWeekFormProps {
  /** Is the section readonly? */
  isReadOnly?: boolean;
  /** Map of days to skip */
  skipDaysOfWeek?: SkipDaysOfWeek;
  /** Callback for when `skipDaysOfWeek` is updated */
  onSkipDaysOfWeekUpdate?: (e: SkipDaysOfWeek) => void;
}

export const SkipDaysOfWeekForm: FC<SkipDaysOfWeekFormProps> = ({
  isReadOnly = false,
  skipDaysOfWeek,
  onSkipDaysOfWeekUpdate = noop,
}): JSX.Element => {
  useEffect(() => {
    if (!skipDaysOfWeek) {
      onSkipDaysOfWeekUpdate(getSkipDaysOfWeekStub());
    }
  }, []);

  return (
    <fieldset>
      {skipDaysOfWeek &&
        DAYS_OF_WEEK.map((day) => (
          <CheckboxWrapper key={day} isDisabled={isReadOnly}>
            <Checkbox
              id={`${day}-checkbox`}
              labelId={`${day}-label`}
              name={day}
              status={skipDaysOfWeek?.[day] ? CHECKBOX_STATUS.CHECKED : CHECKBOX_STATUS.UNCHECKED}
              isDisabled={isReadOnly}
              onClick={() =>
                onSkipDaysOfWeekUpdate({ ...skipDaysOfWeek, [day]: !skipDaysOfWeek?.[day] })
              }
            />
            <CheckboxLabel id={`${day}-label`}>{capitalize(day)}s</CheckboxLabel>
          </CheckboxWrapper>
        ))}
    </fieldset>
  );
};
